import { Component } from "react"

/* Components */
import { InnerLayout, Avatar } from "../../components"

/* REST API */
import { statistics, watchAdd, watchRemove } from "../../api/Player"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CalendarIcon, ChipIcon, ClockIcon, CreditIcon, CurrencyIcon, DebitIcon, NetIcon, OperatorIcon, RoundIcon, SessionIcon, StudioIcon, TableIcon, WalletIcon, ArrowIcon, BellIcon } from "./PlayerIcons"

/* Access */
import { isSuperAdmin } from "../../constants/access"

/* Toast */
import { pushToast } from "../../components/Toast"

/* Utils */
import { getAvatar, getCurrency, isEmpty, formatCount, formatDate } from "./PlayerUtils"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import "moment/locale/ru"


/* Widget Information */
class Information extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            information: null,
            waiting: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Action */
    load = (reload = false) => {

        /* Fields */
        const { player } = this.props

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        statistics({ player }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", information: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", information: null })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", information: null })
            }
            else {
                this.setState({ status: "error", information: null })
            }
        }).catch(() => {
            this.setState({ status: "network", information: null })
        })

    }

    /* Open A Game — the numbers of one game are the rounds of that game, so the card jumps there */
    openGame = (item) => {

        /* Fields */
        const { openGame } = this.props

        /* Check Handler */
        if (openGame) {
            openGame({ id: item.id, name: utils.checkValue(item.name, item.game) })
        }
    }

    /* Draw One Number Of The Card */
    _stat = (icon, title, value, tone = "") => {

        return (
            <div className={`plr--stat ${tone}`}>

                <div className="plr--stat-icon">{icon}</div>

                <div className="plr--stat-text">
                    <div className="plr--stat-title">{title}</div>
                    <div className="plr--stat-value small">{value}</div>
                </div>

            </div>
        )
    }

    /* Контроль входа — отметка ставится на playerId, уведомление шлёт интеграция при запуске игры */
    toggleNotify = (value) => {

        /* Fields */
        const { player } = this.props
        const { information, waiting } = this.state

        /* Check Waiting */
        if (waiting) {
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Send to REST API — та же пара «игрок + оператор», что и в списке контроля */
        const info = (information && information.information) ? information.information : {}
        const request = value === 1
            ? watchAdd({ player, operatorID: info.operatorID })
            : watchRemove({ player, operatorID: info.operatorID })

        request.then((response) => {

            /* Saved */
            if (response.status === 200 || response.status === 201) {
                this.setState({
                    waiting: false,
                    information: { ...information, information: { ...information.information, notifyOnLogin: value } },
                })
                pushToast({ text: value === 1 ? t("plr.notifyEnabled") : t("plr.notifyDisabled"), type: "success" })
                return
            }

            /* Anything Else */
            this.setState({ waiting: false })
            pushToast({ text: t("widget.somethingWrong"), type: "error" })

        }).catch(() => {
            this.setState({ waiting: false })
            pushToast({ text: t("widget.somethingWrong"), type: "error" })
        })
    }

    /* Кнопка контроля входа — видна только суперадмину */
    _notify = () => {

        /* Fields */
        const { admin } = this.props
        const { information, waiting } = this.state
        const info = (information && information.information) ? information.information : {}

        /* Check Access */
        if (!isSuperAdmin(admin)) {
            return null
        }

        /* Без оператора отметку не поставить — такой игрок добавляется через «Контроль входа» на списке */
        if (!parseInt(info.operatorID)) {
            return null
        }

        /* Fields */
        const active = parseInt(info.notifyOnLogin) === 1

        return (
            <div
                onClick={() => this.toggleNotify(active ? 0 : 1)}
                className={`plr--profile-chip notify ${active ? "active" : ""} ${waiting ? "waiting" : ""}`}
            >
                <BellIcon size={12} />
                <span>{active ? t("plr.notifyOn") : t("plr.notifyOff")}</span>
            </div>
        )
    }

    /* Draw The Card Of The Player */
    _player = () => {

        /* Fields */
        const { information } = this.state
        const info = information.information ? information.information : {}
        const currency = getCurrency(info.code)

        /* Chips — an empty value is not drawn at all, a dash inside a chip says nothing */
        const chips = [
            { icon: <OperatorIcon size={12} />, value: isEmpty(info.operator) ? "" : info.operator },
            { icon: <CurrencyIcon size={12} />, value: currency },
            { icon: <WalletIcon size={12} />, value: isEmpty(info.balance) ? "" : utils.convertor(parseFloat(info.balance), currency, utils.checkValue(info.isAfter, 0), " ") },
            { icon: <CalendarIcon size={12} />, value: info.lastLogin ? formatDate(info.lastLogin) : "" },
        ].filter((item) => item.value !== "")

        return (
            <div className="plr--profile">

                <Avatar uri={getAvatar(info)} size={64} />

                <div className="plr--profile-text">

                    <div className="plr--profile-name">
                        <span>{utils.checkValue(info.firstName, "—")}</span>
                        {parseInt(info.isTester) === 1 && <span className="plr--tag tester">{t("gtx.tester")}</span>}
                        {parseInt(info.isVip) === 1 && <span className="plr--tag vip">VIP</span>}
                        {parseInt(info.isBlocked) === 1 && <span className="plr--tag blocked">{t("player.blocked")}</span>}
                    </div>

                    <div className="plr--profile-code">{utils.checkValue(info.player, "—")}</div>

                    <div className="plr--profile-chips">
                        {chips.map((item, index) =>
                            <div className="plr--profile-chip" key={`${index}`}>
                                {item.icon}
                                <span>{item.value}</span>
                            </div>
                        )}
                        {this._notify()}
                    </div>

                </div>

            </div>
        )
    }

    /* Draw The Numbers Of The Whole History */
    _numbers = () => {

        /* Fields */
        const { information } = this.state
        const analytic = information.analytic ? information.analytic : {}
        const total = parseFloat(analytic.total) || 0

        return (
            <div className="plr--section">

                <div className="plr--section-head">
                    <div className="plr--section-title">
                        <NetIcon />
                        {t("plr.totalTitle")}
                        <span className="plr--section-note">{t("player.statsAll")}</span>
                    </div>
                </div>

                <div className="plr--stats inner compact">

                    {this._stat(<RoundIcon />, t("plr.roundsShort"), formatCount(analytic.rounds), "blue")}
                    {this._stat(<SessionIcon />, t("player.sessions"), formatCount(analytic.sessions), "cyan")}
                    {this._stat(<ChipIcon />, t("plr.betShort"), utils.convertor(utils.checkValue(analytic.bet, 0), "USD", 1), "violet")}
                    {this._stat(<ClockIcon />, t("plr.timeShort"), utils.converTime(information.time), "orange")}

                </div>

                <div className="plr--stats inner compact">

                    {this._stat(<DebitIcon />, "Debit", utils.convertor(utils.checkValue(analytic.debit, 0), "USD", 1), "red")}
                    {this._stat(<CreditIcon />, "Credit", utils.convertor(utils.checkValue(analytic.credit, 0), "USD", 1), "green")}
                    {this._stat(<NetIcon />, "GGR", utils.convertor(total, "USD", 1), total >= 0 ? "gold" : "red")}

                </div>

            </div>
        )
    }

    /* Draw The Table Of The Games — one row is one game of the player */
    _games = () => {

        /* Fields */
        const { information } = this.state
        const games = information.games && Array.isArray(information.games) ? information.games : []

        /* Check Games */
        if (games.length === 0) {
            return null
        }

        return (
            <div className="plr--section">

                <div className="plr--section-head">
                    <div className="plr--section-title">
                        <TableIcon />
                        {t("plr.games")}
                        <span className="plr--counter">{games.length}</span>
                        <span className="plr--section-note">{t("plr.gamesNote")}</span>
                    </div>
                </div>

                <div className="plr--games">

                    {/* Head */}
                    <div className="plr--games-header">
                        <div className="plr--games-cell plr--games-name">{t("gtx.game")}</div>
                        <div className="plr--games-cell">{t("plr.roundsShort")}</div>
                        <div className="plr--games-cell">{t("plr.betShort")}</div>
                        <div className="plr--games-cell">{t("plr.timeShort")}</div>
                        <div className="plr--games-cell">Debit</div>
                        <div className="plr--games-cell">Credit</div>
                        <div className="plr--games-cell">GGR</div>
                        <div className="plr--games-cell plr--games-arrow" />
                    </div>

                    {/* Body */}
                    {games.map((item, index) => {

                        /* Fields */
                        const total = parseFloat(item.total) || 0

                        return (
                            <div onClick={() => this.openGame(item)} className="plr--games-row" title={t("plr.openGameRounds")} key={`${index}`}>

                                <div className="plr--games-cell plr--games-name">
                                    <div className="plr--games-title">{utils.checkValue(item.name, item.game)}</div>
                                    <div className="plr--games-note">
                                        <StudioIcon size={11} />
                                        {/* Studio — the short code of the studio is read faster than its full name */}
                                        <span className="plr--capital" title={utils.checkValue(item.studio, "")}>{utils.checkValue(item.studioSlug, item.game)}</span>
                                    </div>
                                </div>

                                <div className="plr--games-cell" data-label={t("plr.roundsShort")}>{formatCount(item.rounds)}</div>
                                <div className="plr--games-cell" data-label={t("plr.betShort")}>{utils.convertor(item.bet, "USD", 1)}</div>
                                <div className="plr--games-cell" data-label={t("plr.timeShort")}>{utils.converTime(item.time)}</div>
                                <div className="plr--games-cell debit" data-label="Debit">{utils.convertor(item.debit, "USD", 1)}</div>
                                <div className="plr--games-cell credit" data-label="Credit">{utils.convertor(item.credit, "USD", 1)}</div>

                                <div className={`plr--games-cell strong ${total > 0 ? "green" : ""} ${total < 0 ? "red" : ""}`} data-label="GGR">
                                    {total > 0 && "+ "}
                                    {total < 0 && "- "}
                                    {utils.convertor(Math.abs(total), "USD", 1)}
                                </div>

                                <div className="plr--games-cell plr--games-arrow">
                                    <ArrowIcon size={14} />
                                </div>

                            </div>
                        )
                    })}

                </div>

                <div className="plr--hint">
                    <RoundIcon size={15} />
                    <span>{t("plr.gamesHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { status, information } = this.state

        /* Check Status */
        if (status !== "ok") {
            return <InnerLayout inner status={status} reload={() => this.load(true)} />
        }

        /* Fields */
        const games = information.games && Array.isArray(information.games) ? information.games : []

        return (
            <div className="plr--information">

                {/* Draw The Card Of The Player */}
                {this._player()}

                {/* Draw The Numbers */}
                {this._numbers()}

                {/* Draw The Games */}
                {this._games()}

                {/* Empty */}
                {games.length === 0 &&
                    <div className="plr--empty inner">
                        <TableIcon size={34} />
                        <span>{t("plr.gamesEmpty")}</span>
                    </div>
                }

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    admin: state.admin,
    language: state.language,
})

export default connect(mapStateToProps)(Information)
